<template>
  <div v-loading="loading">
    <img v-if="base64Url" :src="base64Url" :alt="alt" />
  </div>
</template>

<script>
import {delay} from "@/utils";

export default {
  props: {
    src: String,
    alt: String,
    loading: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    src: {
      immediate: true,
      handler(val) {
        if(val) {
          this.loadImg(val)
        }
      }
    }
  },
  data() {
    return {
      base64Url: undefined,
    }
  },
  methods: {
    async loadImg(url) {
      try {
        this.$emit('update:loading', true)
        let result = await this.getBase64Image(url)
        await delay(300)
        this.base64Url = result
        await this.$nextTick()
        this.$emit('update:loading', false)
      }catch {
        this.$message.error('获取验证码失败，请重试!')
      }
    },
    getBase64Image(url) {
      return new Promise((resolve, reject) => {
        let image = new Image()
        image.src = url + '?v=' + Math.random() // 处理缓存
        image.crossOrigin = '*' // 支持跨域图片
        image.onload = () => {
          let base64 = this.drawBase64Image(image)
          resolve(base64)
        }
        image.onerror = () => {
          reject()
        }
      })
    },
    drawBase64Image(img) {
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      let dataURL = canvas.toDataURL('image/png')
      return dataURL
    },

  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}

/deep/ {
  .el-loading-spinner {
    margin-top: -12px;
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
